module.exports = __webpack_public_path__ + "4c76a43996239018c73cfbf9bcd5d26c.png";